/**
 * Utility functions for country flag handling
 */

// Map common country names to flag emojis
const COUNTRY_FLAGS: { [key: string]: string } = {
  'deutschland': '🇩🇪',
  'germany': '🇩🇪',
  'österreich': '🇦🇹',
  'austria': '🇦🇹',
  'schweiz': '🇨🇭',
  'switzerland': '🇨🇭',
  'frankreich': '🇫🇷',
  'france': '🇫🇷',
  'italien': '🇮🇹',
  'italy': '🇮🇹',
  'spanien': '🇪🇸',
  'spain': '🇪🇸',
  'niederlande': '🇳🇱',
  'netherlands': '🇳🇱',
  'belgien': '🇧🇪',
  'belgium': '🇧🇪',
  'polen': '🇵🇱',
  'poland': '🇵🇱',
  'tschechien': '🇨🇿',
  'czech republic': '🇨🇿',
  'dänemark': '🇩🇰',
  'denmark': '🇩🇰',
  'schweden': '🇸🇪',
  'sweden': '🇸🇪',
  'norwegen': '🇳🇴',
  'norway': '🇳🇴',
  'finnland': '🇫🇮',
  'finland': '🇫🇮',
  'vereinigtes königreich': '🇬🇧',
  'united kingdom': '🇬🇧',
  'irland': '🇮🇪',
  'ireland': '🇮🇪',
  'portugal': '🇵🇹',
  'griechenland': '🇬🇷',
  'greece': '🇬🇷',
  'türkei': '🇹🇷',
  'turkey': '🇹🇷',
  'kroatien': '🇭🇷',
  'croatia': '🇭🇷',
  'slowenien': '🇸🇮',
  'slovenia': '🇸🇮',
  'slowakei': '🇸🇰',
  'slovakia': '🇸🇰',
  'ungarn': '🇭🇺',
  'hungary': '🇭🇺',
  'rumänien': '🇷🇴',
  'romania': '🇷🇴',
  'bulgarien': '🇧🇬',
  'bulgaria': '🇧🇬',
  'luxemburg': '🇱🇺',
  'luxembourg': '🇱🇺',
  'liechtenstein': '🇱🇮',
  'monaco': '🇲🇨',
  'san marino': '🇸🇲',
  'vatikanstadt': '🇻🇦',
  'vatican city': '🇻🇦'
};

/**
 * Get country flag emoji from country name (from display name or geocode result)
 * @param countryName Country name (can be from display_name parsing or geocode result)
 * @returns Flag emoji or globe emoji as fallback
 */
export const getCountryFlag = (countryName: string): string => {
  if (!countryName) return '🌍';
  
  const country = countryName.trim().toLowerCase();
  
  // Direct match
  let flag = COUNTRY_FLAGS[country];
  if (flag) return flag;
  
  // Fuzzy matching - try partial matches
  for (const [key, value] of Object.entries(COUNTRY_FLAGS)) {
    if (country.includes(key) || key.includes(country)) {
      flag = value;
      break;
    }
  }
  
  return flag || '🌍'; // Default globe emoji
};

/**
 * Extract country name from Nominatim display_name
 * @param displayName Full display name from Nominatim
 * @returns Country name (last part after splitting by comma)
 */
export const extractCountryFromDisplayName = (displayName: string): string => {
  if (!displayName) return '';
  const parts = displayName.split(', ');
  return parts[parts.length - 1]?.trim() || '';
};
